/* The Other Side — Maison theme behaviour. No dependencies. */
(function () {
  var d = document, w = window;
  d.documentElement.classList.remove('no-js');
  var reduce = w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function ready(fn) { d.readyState !== 'loading' ? fn() : d.addEventListener('DOMContentLoaded', fn); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }

  ready(function () {
    /* stroke lengths for line-drawing SVGs */
    $$('.draw').forEach(function (svg) {
      $$('path,line,circle,polyline,rect', svg).forEach(function (el) {
        try { var L = Math.ceil(el.getTotalLength()); el.style.setProperty('--len', L); el.style.strokeDasharray = L; el.style.strokeDashoffset = reduce ? 0 : L; } catch (e) {}
      });
    });

    /* reveal on scroll */
    var targets = $$('.rv,.rv-img,.draw,.m-dial,.m-weeks,.m-ch,.m-signoff,[data-count],.m-hero');
    if ('IntersectionObserver' in w && !reduce) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (!e.isIntersecting) return;
          var el = e.target; el.classList.add('is-in');
          if (el.classList.contains('draw')) $$('path,line,circle,polyline,rect', el).forEach(function (p) { p.style.strokeDashoffset = 0; });
          if (el.hasAttribute('data-count')) count(el);
          io.unobserve(el);
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.12 });
      targets.forEach(function (t) { io.observe(t); });
    } else {
      targets.forEach(function (t) { t.classList.add('is-in'); if (t.hasAttribute('data-count')) t.textContent = t.getAttribute('data-count'); });
    }
    var hero = d.querySelector('.m-hero'); if (hero) setTimeout(function () { hero.classList.add('is-in'); }, 80);

    function count(el) {
      var to = parseFloat(el.getAttribute('data-count')); if (isNaN(to)) return;
      var dur = 1800, t0 = null, dec = (el.getAttribute('data-count').split('.')[1] || '').length;
      function step(ts) { if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / dur), e = 1 - Math.pow(1 - p, 3);
        el.textContent = (to * e).toFixed(dec); if (p < 1) requestAnimationFrame(step); }
      requestAnimationFrame(step);
    }

    /* header: transparent over dark heroes, glass when scrolled */
    var hd = d.querySelector('.m-header');
    if (hd) {
      var over = d.body.classList.contains('has-dark-hero');
      if (over) hd.classList.add('is-over');
      var onScroll = function () { var y = w.scrollY || 0; hd.classList.toggle('is-stuck', y > 40 || !over); };
      onScroll(); w.addEventListener('scroll', onScroll, { passive: true });
    }
    /* mobile drawer */
    var dr = d.querySelector('.m-drawer'), bg = d.querySelector('.m-burger');
    function drawer(open) { if (!dr) return; dr.classList.toggle('is-open', open); dr.setAttribute('aria-hidden', !open); if (bg) bg.setAttribute('aria-expanded', open); d.body.style.overflow = open ? 'hidden' : ''; }
    if (bg) bg.addEventListener('click', function () { drawer(true); });
    $$('.m-drawer__close,.m-drawer a').forEach(function (b) { b.addEventListener('click', function () { drawer(false); }); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') drawer(false); });

    /* pillars wheel */
    $$('.m-pillars').forEach(function (box) {
      var segs = $$('.seg', box), items = $$('.m-plist li', box), name = box.querySelector('.m-wheel__name'), def = box.querySelector('.m-wheel__def'), day = box.querySelector('.m-wheel__day');
      var i = 0, timer = null;
      function show(k) {
        i = k; segs.forEach(function (s, j) { s.classList.toggle('on', j === k); });
        items.forEach(function (s, j) { s.classList.toggle('on', j === k); });
        var it = items[k]; if (!it) return;
        if (name) name.textContent = it.getAttribute('data-name');
        if (def) def.textContent = it.getAttribute('data-def');
        if (day) day.textContent = it.getAttribute('data-day');
      }
      function auto() { clearInterval(timer); if (!reduce) timer = setInterval(function () { show((i + 1) % items.length); }, 3600); }
      items.forEach(function (it, k) {
        it.addEventListener('mouseenter', function () { show(k); clearInterval(timer); });
        it.addEventListener('click', function () { show(k); clearInterval(timer); });
        it.addEventListener('mouseleave', auto);
      });
      $$('.lbl', box).forEach(function (l, k) { l.addEventListener('click', function () { show(k); clearInterval(timer); }); });
      show(0); auto();
    });

    /* article: progress, toc, mobile cta, P.S. after signature */
    var prose = d.querySelector('.m-prose');
    if (prose) {
      var bar = d.querySelector('.m-progress'), mc = d.querySelector('.m-mcta'), toc = d.querySelector('.m-toc nav');
      var hs = $$('h2', prose);
      hs.forEach(function (h, k) {
        if (!h.id) h.id = 's-' + (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '').slice(0, 60) || 's' + k;
        if (toc) { var a = d.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent; toc.appendChild(a); }
      });
      if (toc && !hs.length) toc.parentNode.style.display = 'none';
      var links = toc ? $$('a', toc) : [];
      var slot = d.querySelector('.m-signoff .ps-slot');
      $$('.ps', prose).forEach(function (p) { if (slot) slot.appendChild(p); });
      var endEl = d.querySelector('.m-endcard') || prose;
      var tick = function () {
        var r = prose.getBoundingClientRect(), h = r.height - w.innerHeight * .6;
        var p = Math.max(0, Math.min(1, -r.top / (h > 0 ? h : 1)));
        if (bar) bar.style.transform = 'scaleX(' + p + ')';
        if (mc) { var er = endEl.getBoundingClientRect(); mc.classList.toggle('show', p > .18 && er.top > w.innerHeight); }
        var cur = -1; hs.forEach(function (h, k) { if (h.getBoundingClientRect().top < 160) cur = k; });
        links.forEach(function (a, k) { a.classList.toggle('on', k === cur); });
      };
      tick(); w.addEventListener('scroll', tick, { passive: true });
    }


    /* story timeline: the burgundy line follows the reader */
    $$('.m-chapters').forEach(function (box) {
      var fg = box.querySelector('.m-chapters__line .fg'); if (!fg) return;
      fg.style.transition = 'none'; fg.style.strokeDasharray = 1000;
      var upd = function () { var r = box.getBoundingClientRect(), vh = w.innerHeight;
        var p = Math.max(0, Math.min(1, (vh * .6 - r.top) / r.height)); fg.style.strokeDashoffset = 1000 * (1 - p); };
      upd(); w.addEventListener('scroll', upd, { passive: true });
    });

    /* share */
    $$('[data-share]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (navigator.share) { e.preventDefault(); navigator.share({ title: d.title, url: location.href }).catch(function () {}); }
      });
    });
    $$('[data-copy]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); if (navigator.clipboard) navigator.clipboard.writeText(location.href).then(function () { a.textContent = 'Link copied'; }); });
    });

    /* direct-to-checkout buy buttons (outside the landing sections) */
    $$('form[data-direct]').forEach(function (f) {
      f.addEventListener('submit', function (e) {
        if (!w.fetch) return; e.preventDefault();
        var b = f.querySelector('[type=submit]'); if (b) { b.disabled = true; b.style.opacity = .7; }
        var id = f.querySelector('[name=id]').value;
        fetch((w.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/clear.js', { method: 'POST' })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: 1 }] }) }); })
          .then(function (r) { if (!r.ok) throw 0; location.href = '/checkout'; })
          .catch(function () { f.submit(); });
      });
    });
  });
})();
